export default function AttendanceSettings() {
  return (
    <div style={styles.wrap}>
      <div style={styles.title}>Attendance Settings</div>
      <div style={styles.text}>Attendance uses the member list from Church Management.</div>
    </div>
  );
}

const styles = {
  wrap: {
    display: "grid",
    gap: 10,
    padding: 6,
  },
  title: {
    color: "#0f172a",
    fontSize: 18,
    fontWeight: 800,
  },
  text: {
    color: "#475569",
    fontSize: 14,
    lineHeight: 1.6,
  },
};
